module.exports = __webpack_public_path__ + "static/media/omocestus_rufipes_003_APA.ac53fe43.mp3";